class ResultCodeType {
  static readonly success_200: number = 200; //请求成功
  static readonly token_expired: number = 4001; //token失效

  static readonly awaken_0_no_have: number = 0; //0 不存在唤醒记录, 此时停止轮训
  static readonly awaken_1_ing: number = 1; //1: 唤醒中, 继续轮训
  static readonly awaken_2_success: number = 2; // 唤醒成功, 停止轮训;
  static readonly awaken_3_failt: number = 3; //唤醒失败, 停止轮训
}

export default ResultCodeType;
